import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
export const defaultFeatureFlags = {
  replaceCategoriesOnAppTilesWithVendorName: false,
  hideInstallDownloadCountsEnabled: false,
  showAppRequestPlaceholder: false,
  enableNewAndNoteworthyApps: false,
  sortingLogicForCategoryFilter: 'default',
  enableRequestAppCtaCopyChange: false,
  enableBugBountyProgram: false,
  enableTrialExpiryBanner: false,
  enableCloudFortifiedAppsDiscovery: false,
  showMessageForFreeAppSupportForSandbox: false,
  'confluence.frontend.invite-from-github.cohort': 'not-enrolled',
  enableWebpImage: false,
  showCustomBackendErrorsFromUpm: false,
  enableFreeStarterTierFilter: false,
  useInContextInstallFlow: false,
  showMarketplacePartnerTiers: false,
  fetchBugBountyStatusFromBackend: false,
  disableAppInstall: false,
  showManageAppRequestAlternativeLayout: false,
  spaRoutingForPartnerApps: false,
  spaRoutingForPartnerDetails: false,
  spaRoutingForPartnerPayment: false,
  disableAllHostingFromPromotionsDropdown: false,
  spaRoutingForPartnerReports: false,
  reviewsCompliancePrompt: false,
  displayAuditTabInManagePartnerPage: true,
  useAmktFrontendAthreosManagePartners: false,
  enableUpdateByCatalogServiceCall: false,
  enableThirtyFiveKPricingTiers: false,
  enableInContextAppRequest: false,
  showCompatibleSiteProducts: false,
  enableInProductHelpPartnerReporting: false,
  strideHipchatBanners: false,
  showTrustSignalsInManageAppRequests: false,
  showDatePickerOnManagePricingTab: false,
  enableLogAccessByDefaultMessage: false,
  showBenchmarkingUiDropdown: false,
  showDecomposedReviews: false,
  showQualtricsSurvey: false,
  enableEmailSubscription: false
};
const FeatureFlags = /*#__PURE__*/React.createContext(defaultFeatureFlags);
export function useFeatureFlags() {
  return useContext(FeatureFlags);
}
export function withFeatureFlags(WrappedComponent) {
  return function FeatureFlagsHOC(props) {
    return /*#__PURE__*/React.createElement(FeatureFlags.Consumer, null, featureFlags => {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, featureFlags, props));
    });
  };
}
export default FeatureFlags;